'use client'

import type { PropsWithChildren } from 'react'

export const DialogModalHeaderHeadline = ({ children }: PropsWithChildren) => {
  return <div className="mb-2">{children}</div>
}
